<template>
  <div class="min-h-screen bg-gray-100 p-6">
    <div class="bg-white shadow-sm border border-gray-200 rounded-lg mb-4">
      <nav class="flex justify-start space-x-8 px-6" aria-label="Tabs">
        <button
          v-for="tab in tabs"
          :key="tab"
          @click="activeTab = tab"
          :class="[
            'py-4 px-1 text-sm font-medium border-b-2 transition-colors duration-150 whitespace-nowrap',
            activeTab === tab
              ? 'border-app-900 text-app-900'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
          ]"
        >
          {{ tab }}
        </button>
      </nav>
    </div>

    <password-settings v-if="activeTab === tabs[0]" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import PasswordSettings from "../components/app-settings/PasswordSettings.vue";

const tabs = ref(["Password"]);
const activeTab = ref(tabs.value[0]);
</script>
